import { Routes } from '@angular/router';

export const mainRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./app/routes/app.routes'),
    },
    //* Auth routes
    // {
    //     path: 'auth',
    //     loadChildren: () => import('./app/routes/auth.routes'),
    // },
    // * Error Redirect
    {
        path: '**',
        redirectTo: '/home'
    }
];
